import React from 'react';
import PropTypes from 'prop-types';

export class ButtonIcon extends React.Component {

    render() {
        const {
            icon,
            disabled,
            className,
            style,
            onClick,
        } = this.props;

        const disableStyle = disabled ? { opacity: 0.5 } : {};

        return (
            <button
                style={{ ...disableStyle, ...style }}
                disabled={disabled}
                className={`button-icon ${className} waves-effect`}
                onClick={onClick}
            >
                <i className="material-icons">
                    {icon}
                </i>
            </button>
        );
    }

}

ButtonIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/ButtonIcon.jsx